import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout.js';
import Home from '../pages/Home/Home.js';
import About from '../pages/About/About.js';
import Contact from '../pages/Contact/Contact.js';
import Profile from '../pages/Profile/Profile.js';
import Project from '../pages/Project/Project.js';
import Portfolio from '../pages/Portfolio/Portfolio.js';
import Services from '../pages/Services/Services.js';
import Blog from '../pages/Blog/Blog.js';
import AdminLogin from '../pages/AdminLogin/AdminLogin.js';
import AdminDashboard from '../pages/AdminDashboard/AdminDashboard.js';
import NotFound from '../pages/NotFound/NotFound.js';
import AdminRoute from './AdminRoute.js';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="profile" element={<Profile />} />
        <Route path="blog" element={<Blog />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="projects" element={<Portfolio />} />
        <Route path="services" element={<Services />} />
        <Route path="services/:type" element={<Services />} />
        <Route path="project/:id" element={<Project />} />
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="admin" element={<AdminRoute />}>
          <Route index element={<AdminDashboard />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
